import { Helmet } from 'react-helmet-async';

export default function SEO({ title, description, path = '' }) {
  const fullTitle = title || 'Power-Multiservice';
  const fullDescription = description || 'Professionel rengøring til private og erhverv i Nørre Aaby og omegn. Få et uforpligtende tilbud fra Power-Multiservice.';
  const canonicalUrl = `https://power-multiservice.dk${path}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={fullDescription} />
      <link rel="canonical" href={canonicalUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={fullDescription} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={canonicalUrl} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={fullDescription} />
    </Helmet>
  );
}
